import { Injectable } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item';
import { nav_path } from '../../app-routing.module';

@Injectable({ providedIn: 'root' })
export class MenuService {
  public readonly mainMenu: MenuItem[] = [
    { icon: 'home', name: 'Home', routerLink: [nav_path.home] },
    { icon: 'work_history', name: 'Portfolio', routerLink: [nav_path.portfolio] },
    { icon: 'library_books', name: 'Blog', routerLink: [nav_path.stories] },
    // { icon: 'history_edu', name: 'New Story', routerLink: [nav_path.newStory] },
    // { icon: 'article', name: 'All Stories', routerLink: [nav_path.stories] },
    // { icon: 'library_books', name: 'My Stories', routerLink: [nav_path.privateStories] }
  ];

  public readonly adminMenu: MenuItem[] = [
    { name: 'Dashboard', icon: 'space_dashboard', routerLink: [nav_path.admin],
      description: 'Manage admin components throughout this website.' },
    { name: 'Categories', icon: 'category', routerLink: [nav_path.adminCategories],
      description: 'Manage story categories.' },
    { name: 'Comments', icon: 'comment', routerLink: [nav_path.adminComments],
      description: 'Manage story comments.' },
    { name: 'File Manager', icon: 'snippet_folder', routerLink: [nav_path.adminFileManager],
      description: 'Manage files used throughout the website.' },
    { name: 'Tags', icon: 'tag', routerLink: [nav_path.adminTags],
      description: 'Manage story tags.' },
    { name: 'Stories', icon: 'feed', routerLink: [nav_path.adminStories],
      description: 'Manage stories posted throughout this website.' },
    { name: 'Users', icon: 'manage_accounts', routerLink: [nav_path.adminUsers],
      description: 'Manage users accounts for this website.' }
  ];

  public readonly userActions: MenuItem[] = [
    { name: 'Profile', icon: 'manage_accounts', routerLink: [nav_path.profile]}
  ];
}
